<template>
  <div>
    <b-jumbotron>
      <b-row>
        <b-col>
          <b-row align-h="start">
            <font-awesome-layers full-width class="fa-3x logo">
              <font-awesome-icon icon="square" style="color: #85458a" />
              <font-awesome-icon
                icon="briefcase-medical"
                transform="shrink-7"
                style="color: white"
              />
            </font-awesome-layers>
            <h5>Surgical Cases</h5>
          </b-row>
        </b-col>
        <b-col offset="4" style="text-align: right">
          <b-button
            id="idNewBtn"
            size="sm"
            variant="outline-primary"
            @click="handleNewBtnClicked"
          >New</b-button>
        </b-col>
      </b-row>
      <b-row align-h="end">
        <b-col cols="3">
          <b-form-input
            v-model="filter"
            type="search"
            id="idFilterInput"
            placeholder="Type to Search"
            size="sm"
          ></b-form-input>
        </b-col>
      </b-row>
    </b-jumbotron>
    <div v-if="!showSpinner" style="margin: 1rem 1rem;">
      <b-table
        style="text-align: left"
        id="idSurgicalCasesTable"
        head-variant="light"
        fixed
        outlined
        per-page="20"
        responsive
        small
        hover
        show-empty
        selectable
        select-mode="single"
        :items="surgicalCases"
        :current-page="currentPage"
        :fields="fields"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        @row-clicked="handleCaseClicked"
        @filtered="onFiltered"
      ></b-table>
      <b-pagination
        style="margin-right: 1rem"
        v-model="currentPage"
        :total-rows="totalRows"
        first-number
        last-number
        per-page="20"
        align="right"
      />
    </div>
    <b-spinner variant="warning" class="m-5" style="width: 3rem; height: 3rem;" v-if="showSpinner" />
  </div>
</template>

<script>
import _ from "lodash";
import moment from "moment";

export default {
  data() {
    return {
      sortBy: "surgeryStartDateTime",
      sortDesc: true,
      totalRows: 1,
      currentPage: 1,
      filter: "",
      showSpinner: true,
      surgicalCases: [],
      bearer: {},
      opts: {},
      fields: [
        { key: "caseID", sortable: true },
        { key: "status", sortable: true },
        {
          key: "surgeryStartDateTime",
          sortable: true,
          formatter: this.formatSurgeryDate
        },
        { key: "hospitalName", sortable: true },
        { key: "surgeonName", sortable: true },
        { key: "coveringReps", sortable: true }
      ]
    };
  },
  methods: {
    formatSurgeryDate(value) {
      return moment(value).format("M/D/YYYY, h:mm A");
    },
    handleNewBtnClicked() {
      this.$router.push({
        path: "surgicalCaseForm",
        query: { id: null }
      });
    },
    handleEditClicked(surgicalCaseId) {
      this.$router.push({
        path: "surgicalCaseForm",
        query: { id: surgicalCaseId }
      });
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    handleCaseClicked(item) {
      this.$router.push({
        path: "surgicalCase",
        query: { id: item.caseID }
      });
    },
    coveringReps(coveringReps) {
      var reps = "";
      coveringReps.forEach(rep => {
        reps += rep.firstName;
        reps += " ";
        reps += rep.lastName;
        reps += ", ";
      });
      // Remove last comma
      reps = reps.slice(0, -2);
      return reps;
    }
  },
  created() {},
  async mounted() {
    this.showSpinner = true;
    this.$surgicalCaseApi.surgicalcasesGet().then(
      cases => {
        this.surgicalCases = cases.map(item => {
          return {
            caseID: item.metadata.surgicalCaseId,
            status: item.metadata.commentedCaseState.surgicalCaseState,
            surgeryStartDateTime: _.has(item, "surgeryStartDateTime")
              ? item.surgeryStartDateTime
              : "",
            hospitalName: _.has(item, "hospitalName") ? item.hospitalName : "",
            surgeonName: _.some(item.surgeon, _.isNotEmpty)
              ? item.surgeon.firstName + " " + item.surgeon.lastName
              : "",
            coveringReps: _.has(item, "coveringReps")
              ? this.coveringReps(item.coveringReps)
              : ""
          };
        });
        this.totalRows = this.surgicalCases.length;

        this.showSpinner = false;
      },
      error => {
        this.showSpinner = false;
        // eslint-disable-next-line
        console.error(error);
      }
    );
  }
};
</script>